import './backgroundImg.css';

export default function BackgroundImg({background, customClass}) {
    return (
        <div className={`background-image-container ${customClass}`}>
            {background}
        </div>
    )
}